import { dataHooks } from '../../../../../../libs/dataHooks';

export const categoryTagDataHooks = dataHooks<{
  item: { active: boolean };
  seoLink: {};
}>('category');
